import { style, styleVariants } from "@vanilla-extract/css";

import { vars } from "~/styles/tokens.css";

// Vertical flex column. Children lay out top-to-bottom with a gap
// pulled from the semantic spacing scale.
const base = style({
  display: "flex",
  flexDirection: "column",
});

export const stackGap = styleVariants({
  none: [base, { gap: vars.space.none }],
  xs: [base, { gap: vars.space.xs }],
  sm: [base, { gap: vars.space.sm }],
  md: [base, { gap: vars.space.md }],
  lg: [base, { gap: vars.space.lg }],
  xl: [base, { gap: vars.space.xl }],
  "2xl": [base, { gap: vars.space["2xl"] }],
  "3xl": [base, { gap: vars.space["3xl"] }],
});

export const stackAlign = styleVariants({
  start: { alignItems: "flex-start" },
  center: { alignItems: "center" },
  end: { alignItems: "flex-end" },
  stretch: { alignItems: "stretch" },
});
